export default "__VITE_ASSET__194fdeed__"